(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7813],{

/***/ 97813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M10Hero": function() { return /* reexport */ M10Hero; },
  "default": function() { return /* reexport */ M10Hero; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(21175);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/dist/emotion-element-4fbd89c5.browser.esm.js + 1 modules
var emotion_element_4fbd89c5_browser_esm = __webpack_require__(32733);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/link.js
var next_link = __webpack_require__(92072);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/theme/breakpoints.ts
var breakpoints = __webpack_require__(65739);
;// CONCATENATED MODULE: ./src/shared/hooks/useModule/context/ModuleContext.tsx

const ModuleContext = /*#__PURE__*/(0,react.createContext)({
  index: 1
});
;// CONCATENATED MODULE: ./src/shared/hooks/useModule/useModule.ts


const useModule = () => {
  return (0,react.useContext)(ModuleContext);
};
// EXTERNAL MODULE: ./src/theme/index.ts + 6 modules
var theme = __webpack_require__(49577);
;// CONCATENATED MODULE: ./src/shared/hooks/useModule/useModuleTheme.ts




const useModuleTheme = _ref => {
  let {
    backgroundColor
  } = _ref;
  const {
    colors
  } = useTheme();
  const backgroundColorValue = usePotentialThemeColor(backgroundColor || ''); // Get text color from background color if not set

  const textColor = useMemo(() => {
    // Fallback to background color
    return getTextColor(backgroundColorValue || colors.white);
  }, [backgroundColorValue]); // Get button shade based on background color

  const buttonShade = useMemo(() => {
    return readableColorIsBlack(backgroundColorValue || colors.white) ? 'dark' : 'light';
  }, [backgroundColorValue]);
  return {
    backgroundColor: backgroundColorValue,
    textColor,
    buttonShade
  };
};
;// CONCATENATED MODULE: ./src/shared/hooks/useModule/index.ts


// EXTERNAL MODULE: ./src/components/modules/M10Hero/M10Hero.module.css
var M10Hero_module = __webpack_require__(69277);
var M10Hero_module_default = /*#__PURE__*/__webpack_require__.n(M10Hero_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/modules/M10Hero/M10Hero.tsx


const _excluded = ["image", "video", "headline", "subHeadline", "callToAction", "heroHeight", "mediaLayout", "backgroundColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const M10Hero = _ref => {
  let {
    image,
    video,
    headline,
    subHeadline,
    callToAction,
    heroHeight,
    mediaLayout = 'full',
    backgroundColor = '#ffffff'
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const {
    index
  } = useModule();
  const {
    sizes
  } = (0,emotion_element_4fbd89c5_browser_esm.u)();
  const shouldDisplayImage = video && video.length > 0 ? false : true;
  const imageSizes = {
    full: `${breakpoints/* queries.xs */.o$.xs} 100vw, ${breakpoints/* queries.pageMax */.o$.pageMax} 100vw, ${sizes.pageMaxWidth}px`,
    right: `${breakpoints/* queries.xs */.o$.xs} 100vw, ${breakpoints/* queries.pageMax */.o$.pageMax} 50vw, ${sizes.pageMaxWidth / 2}px`,
    left: `${breakpoints/* queries.xs */.o$.xs} 100vw, ${breakpoints/* queries.pageMax */.o$.pageMax} 50vw, ${sizes.pageMaxWidth / 2}px`
  };
  const m10Wrapper = (0,clsx_m/* default */.Z)((M10Hero_module_default()).m10Wrapper, (M10Hero_module_default())[`${heroHeight}Height`]);
  const m10Content = (0,clsx_m/* default */.Z)((M10Hero_module_default()).m10Content, (M10Hero_module_default())[`${mediaLayout}Media`], {
    [(M10Hero_module_default()).splitMedia]: mediaLayout !== 'full',
    [(M10Hero_module_default()).left]: mediaLayout == 'left'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleContainer */.EM, _objectSpread(_objectSpread({}, rest), {}, {
    hasPadding: false,
    isHero: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (M10Hero_module_default()).heroPadding,
      style: {
        backgroundColor: mediaLayout == 'full' ? '#ffffff' : backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: m10Wrapper,
        style: {
          maxWidth: sizes.pageMaxWidth
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: m10Content,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* AlignContent */.tk, {
            alignment: "left",
            position: "center",
            textColor: (0,dist.getTextColor)(),
            children: [headline ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              className: mediaLayout == 'full' ? (M10Hero_module_default()).headlineWidth : (M10Hero_module_default()).fullWidth,
              as: "header",
              variant: "display2",
              color: backgroundColor !== ('#ffffff' || 0) ? 'neutralWhite' : 'bodyColor',
              children: headline
            }) : null, subHeadline ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              className: mediaLayout == 'full' ? (M10Hero_module_default()).subHeadlineWidth : (M10Hero_module_default()).fullWidth,
              as: "span",
              color: backgroundColor !== ('#ffffff' || 0) ? 'neutralWhite' : 'bodyColor',
              children: subHeadline
            }) : null, callToAction ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: callToAction.url,
              passHref: true,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                variant: "secondary",
                children: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title
              })
            }) : null]
          }), image || video ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,clsx_m/* default */.Z)((M10Hero_module_default()).mediaWrapper, {
              [(M10Hero_module_default()).videoAspect]: !shouldDisplayImage && video
            }),
            children: [shouldDisplayImage && image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, {
              src: image.src,
              alt: image.alt,
              layout: "fill",
              objectFit: "cover",
              sizes: imageSizes[mediaLayout],
              priority: index < 2
            }) : null, !shouldDisplayImage && video ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Video */.nk, {
              muted: false,
              controls: true,
              src: video,
              posterSrc: image === null || image === void 0 ? void 0 : image.src,
              cover: true,
              hasMaxHeight: true
            }) : null]
          }) : null]
        })
      })
    })
  }));
};
;// CONCATENATED MODULE: ./src/components/modules/M10Hero/index.ts



/***/ }),

/***/ 69277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mediaWrapper":"M10Hero_mediaWrapper__pU_aR","heroPadding":"M10Hero_heroPadding__e0cYV","m10Wrapper":"M10Hero_m10Wrapper__xnpDY","narrowHeight":"M10Hero_narrowHeight__k5BhU","normalHeight":"M10Hero_normalHeight__TwPnE","tallHeight":"M10Hero_tallHeight__yd_mD","m10Content":"M10Hero_m10Content__rHXnk","subHeadlineWidth":"M10Hero_subHeadlineWidth__xQu3C","headlineWidth":"M10Hero_headlineWidth__iJBxy","fullWidth":"M10Hero_fullWidth__bvQL_","leftMedia":"M10Hero_leftMedia__jPzh4","rightMedia":"M10Hero_rightMedia__FExmq","fullMedia":"M10Hero_fullMedia__duzIZ","splitAlign":"M10Hero_splitAlign__sI9w2","splitMedia":"M10Hero_splitMedia__KyYvh","left":"M10Hero_left__fdmtZ","videoAspect":"M10Hero_videoAspect__Zxhmd"};

/***/ })

}]);